import { Component, Input, ViewChild } from '@angular/core';
import { INeo4j } from '../../interfaces/Neo4j';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { Overview } from '../../abstract/Overview';
import { AFFECT_NODE_JSON, ARE_YOU_SURE, CLOSE, CONTAINER_HIERARCHY, CYPHER, DATA_SERVICE, DATABASE, HYPERFLOWS, METRICS, NODE_DOES_NOT_EXISTS, NODE_LABELS, NODE_PROPERTIES, OVERVIEW, RELATION_DOES_NOT_EXISTS, RELATION_PROPERTIES, RELATIONSHIP_TYPES, SHAPE_PROPERTIES, SIMULATION_INFO, SURE_CHANGE_PROPERTIES, SURE_DELETE_CONTAINER, SURE_DELETE_RELATION, USER } from '../../shared/strings';
import { THEME_CHOOSER } from '../../styles/Canvas';
import { CanvasColorTheme } from '../../interfaces/CanvasColorTheme';
import { convertIntoArrowEnum, convertIntoArrowTypeEnum, convertIntoShapeEnum } from '../../utils/utils';
import { Subscription } from 'rxjs';
import { NotifyDialogService } from '../../services/notify-dialog.service';
import { ShapeRefArray } from '../../clases/ShapeRefArray';
import { ConnectionRef } from '../../clases/ConnectionRef';
import { DataViewer } from '../../abstract/DataViewer';
import { MatIconModule } from '@angular/material/icon';
import { Neo4jCreatorComponent } from '../tab-models/neo4j-creator/neo4j-creator.component';
import { FormsModule } from '@angular/forms';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { ServerResponse } from '../../interfaces/ServerResponse';
import { Record } from '../../interfaces/Record';
import { DatabaseIcon, DatabaseShape, ShapeAsset } from '../../interfaces/DatabaseVisual';
import { ShapeIcon, UIPropierties } from '../../interfaces/ShapeIcon';
import { AbstractShape } from '../../abstract/Shape';
import { Neo4jGeneratorService } from '../../services/neo4j-generator.service';
import { Anchor } from '../../enums/Anchor';
import { ArrowStyle, ArrowType } from '../../enums/ArrowType';
import { Shape } from '../../enums/Shape';
import { BoxMetrics } from '../../interfaces/BoxMetrix';
import { Dictionary } from '../../types/Dictionary';
import { MainComponent } from '../../pages/main/main.component';
import { HyperFlowsCategory } from '../../interfaces/HyperFlows';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltip } from "@angular/material/tooltip";
import { MatToolbarModule } from '@angular/material/toolbar';
import { PropertiesHyperflowsComponent } from '../properties-hyperflows/properties-hyperflows.component';
import { scaleSubtreeFromTopLeft } from '../../utils/MathFunc';
import { PropertiesTableComponent } from '../properties-table/properties-table.component';
import { IField } from '../../interfaces/Field';
import { ToSizeFields } from '../../utils/SizeUtils';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Overlay } from '@angular/cdk/overlay';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SimulationGlobalAverage } from '../../interfaces/Simulation';

@Component({
  selector: 'propierties-overview',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatTooltip,
    MatToolbarModule,
    PropertiesHyperflowsComponent,
    PropertiesTableComponent,
    MatMenuModule,
    ClipboardModule
],
  templateUrl: './propierties-overview.component.html',
  styleUrl: './propierties-overview.component.scss'
})
export class PropiertiesOverviewComponent extends Overview {

  @Input() mainComponent!: MainComponent;
  // @ViewChild(MatMenu) ShapeProps!: MatMenu;
  @ViewChild('shapeMenuTrigger') shapeMenuTrigger!: MatMenuTrigger;
  @ViewChild('nodeMenuTrigger') nodeMenuTrigger!: MatMenuTrigger;
  @ViewChild('relMenuTrigger') relMenuTrigger!: MatMenuTrigger;

  //String definitions
  OVERVIEW = OVERVIEW;
  CONTAINER_HIERARCHY = CONTAINER_HIERARCHY;
  DATA_SERVICE = DATA_SERVICE;
  CYPHER = CYPHER;
  USER = USER;
  DATABASE = DATABASE;
  NODE_LABELS = NODE_LABELS;
  RELATIONSHIP_TYPES = RELATIONSHIP_TYPES;
  NODE_PROPERTIES = NODE_PROPERTIES;
  SHAPE_PROPERTIES = SHAPE_PROPERTIES;
  RELATION_PROPERTIES = RELATION_PROPERTIES;
  AFFECT_NODE_JSON = AFFECT_NODE_JSON;
  RELATION_DOES_NOT_EXISTS=RELATION_DOES_NOT_EXISTS;
  NODE_DOES_NOT_EXISTS=NODE_DOES_NOT_EXISTS;
  ARE_YOU_SURE = ARE_YOU_SURE;
  SURE_DELETE_CONTAINER = SURE_DELETE_CONTAINER;
  SURE_DELETE_RELATION = SURE_DELETE_RELATION;
  METRICS = METRICS;
  SIMULATION_INFO = SIMULATION_INFO;
  CLOSE = CLOSE;
  HYPERFLOWS = HYPERFLOWS;

  neo4jConnection!: INeo4j | null;
  currentFocus!: ShapeRefArray;
  currentRelationFocus!: ConnectionRef;
  hierarchy!: string;
  dbLabels: string[] = [];
  dbRelations: string[] = [];
  currentSentence: string[] = [];
  select: string = this.AFFECT_NODE_JSON[2].value;

  theme_colors = THEME_CHOOSER;

  component!: DataViewer;

  itemFocusSub!: Subscription;
  relationFocusSub!: Subscription;

  addProperty: boolean = false;
  isNeo4jEditor: boolean = false;

  propertyName: string = "";
  propertyValue: string = "";
  databaseIcons: DatabaseIcon[] = [];
  databaseShapes: ShapeAsset[] = [];

  changeLytProperty: boolean = false;
  lytPName: string = "";
  lytPValue: string = "";
  selectedShapeProperty!: IField; 

  showClass: string = "";

  shapeSub: Subscription | null = null;

  inputScaleFactor: number = 1;

  shapeDictionary: { [key: string]: string } = {
    rectangle: "assets/icons/01-46.svg",
    circle: "assets/icons/01-54.svg",
    hexagon: "assets/icons/01-53.svg",
    rhombus: "assets/icons/01-55.svg",
    info_rectangle: "assets/icons/01-38.svg",
    simple_rectangle: "assets/icons/01-32.svg",
    simple_circle: "assets/icons/01-35.svg",
    simple_rhombus: "assets/icons/01-36.svg",
    simple_hexagon: "assets/icons/01-34.svg",
    people_hex: "assets/icons/01-66.svg",
    swim_line_container: "assets/icons/swimlane_icon.svg",
    swim_line_dotted: "assets/icons/01-101.svg",
    dotted_area: "assets/icons/01-96.svg",
    rectangle_area: "assets/icons/01-95.svg",
    simple_area: "assets/icons/box_text_left.svg",
    romboid_left: "assets/icons/01-104.svg",
    romboid_right: "assets/icons/01-105.svg",
    solid_text_rectangle: "assets/icons/01-106.svg",
    trapezium_left: "assets/icons/01-103.svg",
    trapezium_right: "assets/icons/right_trapezoid.svg"
  };


  ToSizeFields = ToSizeFields;

  constructor(
    private notifyDialogService: NotifyDialogService,
    private beNeo4jService: BeNeo4jService,
    private neo4jGeneratorService: Neo4jGeneratorService,
    private overlay: Overlay
  ){super();}

  assignOverviewParameters(component: DataViewer | undefined){
    if(!component)return;
    let sub = component.getDataReadyFocus().subscribe(()=>{
      this.assignOverviewParameters(component);
      sub.unsubscribe();
    });
    if(!component.getConnectionJson())return;
    this.neo4jConnection = component.getConnectionJson();
    if(this.shapeSub) this.shapeSub.unsubscribe();
    this.currentFocus = component.getCurrentFocus();
    this.shapeSub = this.currentFocus.shapeSubject.subscribe(this.onNewShape);
    this.currentRelationFocus = component.getCurrentRelation();
    this.dbLabels = component.getDBLabels();
    this.dbRelations = component.getDBRelations();
    this.hierarchy = JSON.stringify(component.getHierarchy(), null, 2);
    this.currentSentence = component.getCurrentSentence();
    this.component = component;
    if(component instanceof Neo4jCreatorComponent){
      this.isNeo4jEditor = true;
      if(!this.databaseIcons.length)this.getIcons();
      if(!this.databaseShapes.length)this.getShapes();
      return;
    }

    this.isNeo4jEditor = false;
    if (!this.databaseShapes.length) this.getShapes();
  }

  onGenericPropsTable(payload: { field: IField, event: MouseEvent }, trigger: MatMenuTrigger){
    if (!trigger) return;
    const { event } = payload;
    trigger.openMenu();
    const overlayRef = (trigger as any)["_overlayRef"];
    if (overlayRef) {
      overlayRef.updatePositionStrategy(
        this.overlay
          .position()
          .flexibleConnectedTo({ x: event.clientX, y: event.clientY })
          .withPositions([
            { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' }
          ])
      );
    }
    this.selectedShapeProperty = payload.field;
  }

  onNodePropsEdit(){
    this.propertyName = this.selectedShapeProperty.name;
    this.propertyValue = this.selectedShapeProperty.value;
    this.onAddProperty(true);
  }

  onShapePropsEdit(){
    this.lytPName = this.selectedShapeProperty.name;
    this.lytPValue = this.selectedShapeProperty.value;
    this.onChangeLytProperty(true);
  }

  onNewShape = (shape: AbstractShape)=>{
    if(shape.hyperFlows === null || shape.hyperFlows || !shape.dbData) return;
    this.beNeo4jService.getNodeHyperFlows(shape.dbPropierties.hierarchy, shape.dbPropierties.__EDT_UUID__, shape.getLabels()).subscribe({
      next: (res: ServerResponse<HyperFlowsCategory>)=>{
        if(res.result.length==0){
          shape.hyperFlows = null;
          return;
        }
        shape.hyperFlows = res.result;
      }
    });
  }

  onTakeScreenshot(){
    let child = this.currentFocus.getShape()[0];
    this.component.takeChildScreenshot(child, {
      limitTo32Megapixels: true
    });
  }

  chooseShowClass(): string{
    return this.mainComponent.rightMenu.isOverviewActive ? "overview-hidden-sidebar" : "overview-hidden-no-sidebar";
  }

  getShapeFields(shape: AbstractShape): IField[] {
    return ToSizeFields(
      shape.x,
      shape.y,
      shape.width,
      shape.height,
      this.getShapeTextWidth(shape),
      this.getShapeDottedSpacing(shape)
    );
  }

  shapeHasTextWidth(shape: AbstractShape){
    let widthShapes = [Shape.SWIM_LANE_CONTAINER, Shape.SWIM_LANE_DOTTED, Shape.SIMPLE_AREA, Shape.RECTANGLE_AREA];
    return widthShapes.some(sh => sh === shape.shape);
  }

  justTextShapes(shape: AbstractShape){
    let justTextShapes = [Shape.SIMPLE_AREA, Shape.RECTANGLE_AREA];
    return justTextShapes.some(sh => sh === shape.shape);
  }

  getShapeTextWidth(shape: AbstractShape): number | undefined {
    if (!this.shapeHasTextWidth(shape) || shape.fill) return undefined;
    return shape.textWidth > 0 ? shape.textWidth : (this.justTextShapes(shape)) ? Math.ceil(shape.realFontSize) : Math.ceil(shape.ownScale / 2.5);
  }

  shapeIsDotted(shape: AbstractShape){
    let dottedShapes = [Shape.DOTTED_AREA, Shape.SWIM_LANE_DOTTED];
    return dottedShapes.some(sh => sh === shape.shape);
  }

  getShapeDottedSpacing(shape: AbstractShape): number | undefined {
    if (!this.shapeIsDotted(shape)) return undefined;
    return shape.dottedSpacing > 0 ? shape.dottedSpacing : Math.max(1, Math.ceil(shape.realDottedSpacing));
  }

  getMetricsItems(shape: AbstractShape): Dictionary<keyof BoxMetrics, BoxMetrics[keyof BoxMetrics]>[] {
    const fields: Dictionary<keyof BoxMetrics, BoxMetrics[keyof BoxMetrics]>[] = [];
    const metrics = shape.metrics!;

    for (const key of Object.keys(metrics) as Array<keyof BoxMetrics>) {
      fields.push({ name: key, value: metrics[key] });
    }
    return fields;
  }

  normalizeSimulationLabels(label: string){
    return label.replaceAll('_', ' ');
  }

  getSImulationItems(shape: AbstractShape): Dictionary<keyof SimulationGlobalAverage, SimulationGlobalAverage[keyof SimulationGlobalAverage]>[] {
    const fields: Dictionary<keyof SimulationGlobalAverage, SimulationGlobalAverage[keyof SimulationGlobalAverage]>[] = [];
    const sim = shape.simulationAverage!;

    for (const key of Object.keys(sim) as Array<keyof SimulationGlobalAverage>) {
      fields.push({ name: key, value: sim[key] });
    }
    return fields;
  }

  unsubscribe(){
    if(this.itemFocusSub)this.itemFocusSub.unsubscribe();
    if(this.relationFocusSub)this.relationFocusSub.unsubscribe();
  }

  override toggle(){
    if(!this.neo4jConnection) return;
    this.isOverviewActive = !this.isOverviewActive;
  }

  selectType(type: string, event: MouseEvent){
    event.stopPropagation();
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    let typeEnum = convertIntoArrowTypeEnum(type);
    focus.arrowType = typeEnum;
    this.component.updateScreen();
  }

  isCurrentConnTypeOrthogonal() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return false;
    return focus.arrowType !== ArrowType.DIRECT;
  }

  isCurrentConnTypeLShaped() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return false;
    return focus.arrowType === ArrowType.L_SHAPED;
  }

  getConnLArrowHorizontalSpacing() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return 0;
    return focus.lArrowHorizontalSpacing;
  }

  getConnLArrowVerticalSpacing() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return 0;
    return focus.lArrowVerticalSpacing;
  }

  getConnTextPositionPercent() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return 50;
    return Number.isFinite(focus.textPositionPercent) ? focus.textPositionPercent : 50;
  }

  changeLArrowHorizontalSpacing(value: string | number) {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    const parsed = Number(value);
    focus.lArrowHorizontalSpacing = Number.isFinite(parsed) ? parsed : 0;
    this.component.updateScreen();
  }

  changeLArrowVerticalSpacing(value: string | number) {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    const parsed = Number(value);
    focus.lArrowVerticalSpacing = Number.isFinite(parsed) ? parsed : 0;
    this.component.updateScreen();
  }

  changeConnTextPositionPercent(value: string | number) {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    const parsed = Number(value);
    focus.textPositionPercent = Number.isFinite(parsed) ? Math.max(0, Math.min(100, parsed)) : 50;
    this.component.updateScreen();
  }

  selectAnchor(rect: string, position: string, event: MouseEvent) {
    event.stopPropagation();
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    if(rect === 'from') {
      focus.anchorFrom = position as Anchor;
    } else {
      focus.anchorTo = position as Anchor;
    }
    this.component.updateScreen();
  }

  changeTheme(theme: CanvasColorTheme){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length || !this.component) return;

    for (const focus of focusList) {
      switch(this.select){
      case AFFECT_NODE_JSON[0].value:
        this.component.changeAllNodesTheme(focus, theme);
        break; 
      case AFFECT_NODE_JSON[1].value:
        this.component.changeAllNodesPropiertyTheme(focus, theme);
        break;
      case AFFECT_NODE_JSON[2].value:
        focus.setTheme(theme);
        break;
    }
    }
    this.component.updateScreen();
  }

  changeForm(shape: ShapeAsset){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length || !this.component) return;

    const enumValue = convertIntoShapeEnum(shape.shape.id);

      for (const focus of focusList) {
        switch(this.select){
        case AFFECT_NODE_JSON[0].value:
          this.component.changeAllNodesShape(focus, enumValue);
          break; 
        case AFFECT_NODE_JSON[1].value:
          this.component.changeAllNodesPropiertyShape(focus, enumValue);
          break;
        case AFFECT_NODE_JSON[2].value:
          focus.setShape(enumValue);
          break;
      }
    }
    
    
    this.component.updateScreen();
  }

  selectFormChange(shape: ShapeAsset){
    if(this.component instanceof Neo4jCreatorComponent){
      this.selectedShape(shape);
    }else{
      this.changeForm(shape);
    }
  }

  changeArrow(arrow: string){
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return;
    const enumValue = convertIntoArrowEnum(arrow);
    focus.changeType(enumValue);
    this.component.updateScreen();
  }

  getConnAnchor() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return { from: 'any', to: 'any' };
    return {
      from: focus.anchorFrom,
      to: focus.anchorTo
    };
  }

  getConnType() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return ArrowType.SQUARED;
    return focus.arrowType;
  }

  getConnArrowStyle() {
    let focus = this.currentRelationFocus.getConnection();
    if(!focus || !this.component) return ArrowStyle.SOLID;
    return focus.arrowStyle.toString();
  }

  onSelectChange(change: MatSelectChange){
    this.select = change.value;
  }

  deleteRelationFromView(){
    this.notifyDialogService.openDialog(ARE_YOU_SURE, SURE_DELETE_RELATION, true, ()=>{
      let focus = this.currentRelationFocus.getConnection();
      if(!focus)return;
      this.component.deleteRelationship(focus);
      this.currentRelationFocus.setConnection(null);
    });
  }

  deleteContainerFromView(){
    this.notifyDialogService.openDialog(ARE_YOU_SURE, SURE_DELETE_CONTAINER, true, ()=>{
      let focusList = this.currentFocus.getShape();
      if(!focusList.length)return;
      for (const focus of focusList) {
        this.component.deleteContainer(focus);
      }
      this.currentRelationFocus.setConnection(null);
    });
  }

  onAddProperty(value: boolean){
    this.addProperty = value;
  }

  onChangeLytProperty(value: boolean){
    this.changeLytProperty = value;
  }

  changeLYTProperty(){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length)return;
    const propertyName = this.lytPName.toLocaleLowerCase();
    const parsedValue = Number(this.lytPValue);
    if (!this.lytPValue.trim() || !Number.isFinite(parsedValue)) return;

    // Scale accepts fractional factors (for example, 0.5). Other layout
    // fields continue to use integral coordinates and dimensions.
    if (propertyName === "scale" && parsedValue === 0) return;
    const value = propertyName === "scale" ? parsedValue : Math.round(parsedValue);

    let changeAllProperty = ()=>{
      for (const focus of focusList) {
        this.changeItemPosition(focus, value);
      }
    };

    if(focusList.length > 1){
      this.notifyDialogService.openDialog(ARE_YOU_SURE, SURE_CHANGE_PROPERTIES, true, ()=>{
        changeAllProperty();
      });
    }else{
      changeAllProperty();
    }
    this.onChangeLytProperty(false);
    this.component.updateScreen();
  }

  changeItemPosition(focus: AbstractShape, value: number){
    switch (this.lytPName.toLocaleLowerCase()) {
      case "x":
        focus.setPosition(value, focus.y);
        break;
      case "y":
        focus.setPosition(focus.x, value);
        break;
      case "width":
        focus.setSize(value, focus.getSize().y);
        break;
      case "height":
        focus.setSize(focus.getSize().x, value);
        break;
      case "scale":
        scaleSubtreeFromTopLeft(focus, value);
        break;
      case "text width":
        focus.textWidth = value;
        break;
      case "dotted spacing":
        focus.dottedSpacing = value;
        break;
    }
  }

  addPropertyToNode(){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length || focusList.length > 1)return;
    let focus = focusList[0];
    this.neo4jGeneratorService.addNodeProperty(
      focus.getLabels(), 
      focus.dbPropierties.__EDT_UUID__,
      this.propertyName,
      this.propertyValue
    ).subscribe({
      next:(response: ServerResponse<Record>)=>{
        let key = response.result[0].keys[0];
        let properties = response.result[0].fields[key].properties;
        focus.setDBPropierties(properties);
        this.onAddProperty(false);
        this.component.updateScreen();
      }
    });
  }

  addPropertyToRelationship(){
    let focus = this.currentRelationFocus.getConnection();
    if(!focus)return;
    let startNode = focus.iFrom;
    let endNode = focus.iTo!;
    this.neo4jGeneratorService.addRelationshipProperty(
      startNode.getLabels(),
      startNode.dbPropierties.__EDT_UUID__,
      endNode.getLabels(),
      endNode.dbPropierties.__EDT_UUID__,
      focus.type!,
      focus.dbPropierties.__EDT_UUID__,
      this.propertyName,
      this.propertyValue
    ).subscribe({
      next:(response: ServerResponse<Record>)=>{
        let key = response.result[0].keys[0];
        let relation = response.result[0].fields[key];
        focus.setRelation(relation);
        this.onAddProperty(false);
        this.component.updateScreen();
      }
    });
  }

  getShapes(){
    this.beNeo4jService.getShapes().subscribe({
      next: (result: ServerResponse<DatabaseShape>)=>{
        let shapes = result.result;
        this.databaseShapes = Object.entries(this.shapeDictionary).map(([key, value]) => {
          let shape = shapes.find((sh: DatabaseShape)=> sh.id === key);
          return { shape,  asset: value } as ShapeAsset;
        });
      }
    });
  }

  getIcons(){
    this.beNeo4jService.getIcons().subscribe({
      next: (result: ServerResponse<DatabaseIcon>)=>{
        this.databaseIcons = result.result.map((icon: DatabaseIcon)=>{
          icon.image = JSON.parse(icon.image as string);
          return icon
        });
      }
    });
  }

  parseIconData(image: string | ShapeIcon): ShapeIcon{
    return image as ShapeIcon;
  }

  selectedShape(shape: ShapeAsset){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length || focusList.length > 1)return;
    let focus = focusList[0];
    this.neo4jGeneratorService.addNodeShapeOrIcon(focus.getLabels(), focus.dbData.properties.__EDT_UUID__, 'Shape', shape.shape.__EDT_UUID__).subscribe(
      {
        next: (response: ServerResponse<Record>)=>{
          this.changeForm(shape);
          this.component.updateScreen();
        }
      }
    );
  }

  selectedIcon(id: string){
    let focusList = this.currentFocus.getShape();
    if(!focusList.length || focusList.length > 1)return;
    let focus = focusList[0];
    this.neo4jGeneratorService.addNodeShapeOrIcon(focus.getLabels(), focus.dbData.properties.__EDT_UUID__, 'Icon', id).subscribe(
      {
        next: (response: ServerResponse<Record>)=>{
          let key = response.result[0].keys[0];
          let properties = response.result[0].fields[key].properties;
          let ui: any = properties.uiProperties;
          let parsed = JSON.parse(ui) as UIPropierties;
          focus.setIcon(parsed);
          this.component.updateScreen();
        }
      }
    );
  }
}
